/**
 * filename: iconBoxes.js
 * Home page top samll icon boxex
 */

import React, { Component } from 'react';
// import TinyAreaChart from '../charts/tinyAreaChart.js';
import TinyBarChart from '../charts/tinyBarChart.js';
//import TinyLineChart from '../charts/tinyLineChart.js';

export const BoxSingle = (props) => {
  // Used a style const for changing icon box
  // color using props.

  const style = {
    backgroundColor: props.iconbg,
  };

  return (
    <div className="iconbox-single">
      <div className="box-title">
        <div className="circle-icon" style={style}>
          <i className="material-icons">{props.icon}</i>
        </div>
        <div>
          <h5>{props.title}</h5>
          <p>{props.subtitle}</p>
        </div>
      </div>
      <div className="chart">
        {props.children}
      </div>
    </div>
  );
};


class TopBoxes extends Component {
  render() {
    return (
      <div className="iconbox-wrapper">
      {/* {this.props.TotalRevenue ?
        <div className="row">
          <div className="col-md-4">
            <BoxSingle
              iconbg="#258df2"
              icon="supervisor_account"
              title={this.props.TotalClientCount}
              subtitle="Total Clients"
            >
              <TinyBarChart />
            </BoxSingle>
          </div>

          <div className="col-md-4">
            <BoxSingle
              iconbg="#40c741"
              icon="monetization_on"
              title={this.props.TotalRevenue ? this.props.TotalRevenue : '0'}
              subtitle="Revenues"
            >
              <TinyAreaChart />
            </BoxSingle>
          </div>

          <div className="col-md-4">
            <BoxSingle
              iconbg="#fdba2c"
              icon="supervisor_account"
              title={this.props.OnlineUsers ? this.props.OnlineUsers : '0'}
              subtitle="Online Users"
            >
              <TinyLineChart />
            </BoxSingle>
          </div>
        </div>
        :  */}
        <div className="row">
          <div className="col-md-6">
            <BoxSingle
              iconbg="#258df2"
              icon="supervisor_account"
              title={this.props.TotalClientCount}
              subtitle="Total Clients"
            >
              <TinyBarChart />
            </BoxSingle>
          </div>

          <div className="col-md-6">
            <BoxSingle
              iconbg="#40c741"
              icon="supervisor_account"
              title={this.props.TotalStaffCount}
              subtitle="Total Staff"
            >
              <TinyBarChart />
            </BoxSingle>
          </div>
         
          {/* <div className="col-md-4">
            <BoxSingle
              iconbg="#fdba2c"
              icon="supervisor_account"
              title={this.props.OnlineUsers ? this.props.OnlineUsers : '0'}
              subtitle="Online Users"
            >
              <TinyLineChart />
            </BoxSingle>
          </div> */}
        </div>
        {/* } */}
      </div>
    );
  }
};

export default TopBoxes;



// WEBPACK FOOTER //
// ./src/adminCharts/TopBoxes.js